import http from "../http-common";

class PreSessionQuestionsService {
    getAll(token?: string | null) {
        return http.get(`/presession-questions`, {
            headers: token
                ? {
                    authorization: `Bearer ${token}`,
                }
                : undefined,
        });
    }

    getById(id: string, token?: string | null) {
        return http.get(`/presession-questions/${id}`, {
            headers: token
                ? {
                    authorization: `Bearer ${token}`,
                }
                : undefined,
        });
    }

    add(data: any, token?: string | null) {
        return http.post(`/presession-questions/add`, data, {
            headers: token
                ? {
                    authorization: `Bearer ${token}`,
                }
                : undefined,
        });
    }

    update(id: string, data: any, token?: string | null) {
        return http.patch(`/presession-questions/${id}/update`, data, {
            headers: token
                ? {
                    authorization: `Bearer ${token}`,
                }
                : undefined,
        });
    }

    reorder(questionIds: string[], token?: string | null) {
        return http.patch(
            `/presession-questions/reorder`,
            { question_ids: questionIds },
            {
                headers: token
                    ? {
                        authorization: `Bearer ${token}`,
                    }
                    : undefined,
            }
        );
    }

    deactivate(id: string, token?: string | null) {
        return http.delete(`/presession-questions/${id}`, {
            headers: token
                ? {
                    authorization: `Bearer ${token}`,
                }
                : undefined,
        });
    }
}

export default new PreSessionQuestionsService();
